const Id = {
  type: 'string',
  pattern:
    '^[a-zA-Z0-9]{4}-[a-zA-Z0-9]{2}-[23456789ABCDEFGHJKLMNPQRSTWXYZabcdefghijkmnopqrstuvwxyz]{17}$',
};

export default Id;
